import { render, staticRenderFns } from "./comparify.html?vue&type=template&id=29d2d6e2&"
import script from "./comparify.js?vue&type=script&lang=js&"
export * from "./comparify.js?vue&type=script&lang=js&"
import style0 from "./comparify.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports